// false will show team logo, true will show country flag
export const IS_MATCH_INFO_SHOW_COUNTRY_FLAG = true;

export const IS_MULTIPLE_SPORTS_IN_MATCHES_PAGE = false;

export const ENTRANCE_SLIDES_PER_VIEW = 1;

export const ENTRANCE_TRANSITION_SPEED = 900;

export const ENTRANCE_SLIDE_COUNT = 2;

export const FEATURED_MATCH_COUNT = 2;

export const UPCOMING_MATCH_COUNT = 4;

export const PREDICTION_MATCH_COUNT = 2;

export const IS_SHOW_ANIMATE = false;

export const IS_FIXED_TITLE = false;

export const IS_SHOW_OUTRIGHT_TOURNAMENT_IN_OVERVIEW = true;

export const CORRECT_SCORE_DISPLAYED_ROW_COUNT = 3;
